/**
 * Returns video duration in seconds from an object URL (e.g. from URL.createObjectURL(file)).
 * Caller is responsible for creating and revoking the URL.
 * Rejects if the video metadata cannot be loaded.
 */
export function getVideoDurationFromObjectUrl(objectUrl: string): Promise<number> {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');

        video.preload = 'metadata';

        function cleanup() {
            video.remove();
            video.src = '';
        }

        video.addEventListener('loadedmetadata', () => {
            const duration = video.duration;

            cleanup();

            if (Number.isFinite(duration) && duration >= 0) {
                resolve(duration);
            } else {
                reject(new Error('Invalid video duration'));
            }
        });

        video.addEventListener('error', () => {
            cleanup();
            reject(new Error('Failed to load video'));
        });

        video.src = objectUrl;
    });
}
